import React, { useEffect, useState } from 'react';
import Loading from '../components/ui/Loading';
import {
  getMsalInstance,
  getMsalClientId,
  msalScopes,
  MSAL_MAIL_LOGIN_SESSION_KEY,
} from '../auth/msalConfig';

const MicrosoftMailLoginPage = () => {
  const [error, setError] = useState(null);

  useEffect(() => {
    const clientId = getMsalClientId();
    if (!clientId) {
      setError(
        'Microsoft uygulaması yapılandırılmamış. frontend/.env içinde REACT_APP_MSAL_CLIENT_ID ekleyin veya public/index.html içindeki window.ENV.MSAL_CLIENT_ID değerini kontrol edin; ardından npm start ile yeniden başlatın.'
      );
      return;
    }

    const run = async () => {
      const msal = getMsalInstance();
      try {
        await msal.initialize();

        const redirectResult = await msal.handleRedirectPromise();
        if (redirectResult?.account) {
          sessionStorage.removeItem(MSAL_MAIL_LOGIN_SESSION_KEY);
          window.location.replace('/mailcall');
          return;
        }

        if (sessionStorage.getItem(MSAL_MAIL_LOGIN_SESSION_KEY)) {
          return;
        }
        sessionStorage.setItem(MSAL_MAIL_LOGIN_SESSION_KEY, '1');
        await msal.loginRedirect({ scopes: msalScopes });
      } catch (e) {
        const msg = String(e?.message || '');
        const isInteractionBusy =
          e?.errorCode === 'interaction_in_progress' || msg.includes('interaction_in_progress');
        if (isInteractionBusy) {
          return;
        }
        sessionStorage.removeItem(MSAL_MAIL_LOGIN_SESSION_KEY);
        setError(msg || 'Microsoft girişi başlatılamadıı..');
      }
    };

    run();
  }, []);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-6">
        <div
          className="w-full max-w-lg bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded dark:bg-red-900/20 dark:border-red-800 dark:text-red-300"
          role="alert"
        >
          {error}
        </div>
      </div>
    );
  }

  return (
    <Loading fullScreen={true} message="Microsoft'a yönlendiriliyorsunuz..." />
  );
};

export default MicrosoftMailLoginPage;
